/** * 功能: 报告摘要的信息录入 */
<template lang="pug">
  div.report-step1
    report-nav(:mainId="mainId" :title="brief.title" :kind="brief.kind" :status="brief.status" )
    el-form(
      style="height:80vh;"
      :model="brief"
      label-width="90px"
      :rules="briefRules"
      ref="briefRef"
      :size="GLOBAL.SIZE_OF_INPUTBOX")
      el-row
        el-col(:span="16")
          el-row
            el-form-item(label="大标题" prop="title")
              el-input(v-model="brief.title" :disabled="isDisabled")
          el-row(:span="12")
            el-col(:span="12")
              el-form-item(label="报告编号")
                el-input(v-model="brief.code" :disabled="isDisabled")
            el-col(:span="12")
              el-form-item(label="发布日期")
                el-date-picker(v-model="brief.releaseDate" type="date" placeholder="选择日期" :disabled="isDisabled")
          el-row
            el-col(:span="12")
              el-form-item(label="类型")
                el-select(placeholder="请选择报告类型" v-model="brief.reportType" :disabled="isDisabled")
                  el-option(
                    v-for="item in REPORT_TYPE"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value")
            el-col(:span="12")
              el-form-item(label="属性")
                el-select(placeholder="请选择报告属性" v-model="brief.briefType" :disabled="isDisabled")
                  el-option(
                    v-for="item in REPORT_ATTRIBUTE"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value")
          el-row
            el-col(:span="12")
              el-form-item(label="编辑")
                el-input(v-model="brief.createdByName" disabled)
            el-col(:span="12")
              el-form-item(label="作者")
                el-input(v-model="brief.author" :disabled="isDisabled")
          el-row
            el-col(:span="12")
              el-form-item(label="厂牌")
                brandSelect(:disabled="isDisabled" v-model="brief.brand" :brandName="brief.brandName" @brandName="getbrandName")
              el-form-item(label="显示")
                el-radio-group(v-model="brief.kind" :disabled="isDisabled")
                  el-radio(:label="0") 文本
                  el-radio(:label="1") 幻灯
              el-form-item(label="版本号" prop='version')
                el-input(v-model="brief.version" :disabled="isDisabled")
                //- el-input(v-model="brief.brandName")
            el-col(:span="12")
              el-form-item(label="标签")
                NPMKeywordV2.labels(:value="brief.labels" :source="1" ref="labels")
                industryV2(v-model="brief.industry")
          el-row
            el-col(:span="12")
              el-form-item(label="价格" prop="price")
                el-input-number(v-model="brief.price" :precision="2" :step="10" :min="0" :disabled="isDisabled" )
                p(style="display: inline;margin:0 10px") 人民币
            el-col(:span="3")
              el-form-item(label="即将发布")
                el-checkbox(v-model="brief.released" :disabled="isDisabled")
            el-col(:span="3")
              el-form-item(label="独占报告")
                el-checkbox(v-model="brief.isMonopoly" :disabled="isDisabled")
            el-col(:span="6")
              el-form-item(label="限免次数")
                el-input-number(v-model="brief.freeCount" :min="0" :step="10" :disabled="isDisabled" )
          el-row
            //- 关联报告选择框
            el-col(:span="12")
              el-form-item(label="关联报告")
                el-select(placeholder="请选择关联报告" v-model="brief.linkBrief" remote filterable :remote-method="searchReports" :disabled="isDisabled" clearable)
                  el-option(
                    v-for="item in relatedReports"
                    :key="item._id"
                    :label="item.title"
                    :value="item._id")
            el-col(:span="12")
              el-form-item(label="股票代码")
                InputTag(@getData="getStocks" :tagData="brief.stocks" :disabled="isDisabled")
          el-row
            //- 关联词条报告选择框
            el-col.writing-label(:span="12")
              el-form-item(label="关联词条" v-if="brief.kind === 1")
                el-select(placeholder="请选择关联词条" v-model="brief.writings" remote multiple filterable :remote-method="searchBriefs" :disabled="isDisabled" clearable @change="changeWriting")
                  el-option(
                    v-for="item in relatedWritings"
                    v-show="!item.isCheckd"
                    :key="item._id"
                    :label="item.title"
                    :value="item._id")
          el-row(v-if="showParseBtn")
            el-col(:span="24")
              el-form-item(label="PPT解析")
                div.pptx-upload
                  el-upload(
                    ref="pptxUpload"
                    :action="GLOBAL.uploadHost + 'slide/convert'"
                    :headers="headers"
                    name="pptx"
                    :data="{ outline: brief.outline }"
                    accept=".pptx,.ppt"
                    :auto-upload="false"
                    :file-list="pptxFileList"
                    :on-change="onPptxChange"
                    :on-success="onConvertSuccess"
                    :on-error="onConvertError"
                    :limit="1")
                    el-button(type="primary") 点击上传
                    el-button.pptx-parse-btn(
                      type="primary"
                      :disabled="!pptxFileList.length"
                      :loading="parsing"
                      @click.stop="handleParseClick") 一键解析
                    div.el-upload__tip(slot="tip") 只能上传PPT/PPTX文件

        el-col(:span="8")
          el-form-item(label="副标题" prop="subTitle")
            el-input(v-model="brief.subTitle" type="textarea" :autosize="{ minRows: 6 }" :disabled="isDisabled")
          el-form-item(label="配图")
            el-upload(:action='GLOBAL.uploadHost+"brief/header_upload"'
              :headers='headers' name="image" :auto-upload="true"
              accept="image/jpeg,image/png" :show-file-list="false"
              :on-success="handleUploaded" :before-upload="beforeAvatarUpload")
              img(v-if="brief.image" :src='brief.image' class="avatar" style="max-height:100px;max-width: 100%;")
              i.el-icon-plus.avatar-uploader-icon(v-else)
            el-button(v-if="brief.image" icon="el-icon-delete" circle :disabled="isDisabled" @click="handelRemoveImg")
    el-row(type="flex" justify="end")
      el-button-group
        el-button(type="primary" v-if="brief.status <= 0" @click="review") 提交审阅
        el-button(type="primary" @click="handleSaveBrief" :disabled="isDisabled") 保存
</template>

<script>
import FrostIndustry from '@/components/industry'
import InputTag from '@/components/InputTag'
import LabelTag from '@/components/labelTag'
import ReportNav from './components/reportNav'
import brandSelect from '@/components/brandSelect'
import Enum from '@/apis/enum'
import passport from '@/javascripts/passport'
import api from '@/apis/brief'
import industryV2 from '@leadleo/old-industry/IndustryV2.vue'
import NPMKeywordV2 from '@leadleo/old-label/NPMKeywordV2.vue'
export default {
  components: { ReportNav, FrostIndustry, LabelTag, InputTag, brandSelect, industryV2, NPMKeywordV2 },

  computed: {
    isDisabled() {
      return this.brief.status > 0
    },
    relatedWritings() {
      const list = []
      ;(this.relatedbriefs ? this.relatedbriefs : []).concat(this.checkedWritings).forEach(item => {
        if (!list.find(it => it._id === item._id)) {
          list.push(item)
        }
      })
      return list
    },
    showParseBtn() {
      return this.mainId && this.brief.kind === 1
    }
  },

  data() {
    var validatePrice = (rule, value, callback) => {
      if (value < 0) {
        callback(new Error('请输入大于等于0元的价格'))
      } else {
        callback()
      }
    }
    var checkVersion = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入版本号'))
      }
      const reg = /^([1-9]\d|[1-9])(\.([1-9]\d|\d)){1}$/
      if (!reg.test(value)) {
        callback(new Error('请输入正确的版本号，形如1.1'))
      } else {
        callback()
      }
    }
    return {
      REPORT_TYPE: Enum.REPORT_TYPE,
      REPORT_ATTRIBUTE: Enum.BRIEF_ATTRIBUTE,
      headers: passport.headers(),
      briefRules: {
        title: { required: true, message: '请输入标题名称', trigger: 'blur' },
        subTitle: { required: true, message: '请输入摘要内容', trigger: 'blur' },
        price: [{ validator: validatePrice, trigger: 'blur' }],
        version: { required: true, validator: checkVersion, trigger: 'blur' }
      },

      mainId: 0,
      brief: {
        brandName: '',
        reportType: '一级市场',
        briefType: 1,
        industry: [],
        industryId: [],
        labels: [],
        authors: [],
        kind: 0,
        image: '',
        price: 0,
        version: '1.0',
        free: false,
        freeCount: 10,
        released: false,
        isMonopoly: false,
        writings: []
      },
      relatedReports: [], // 选择的关联报告
      relatedbriefs: [], // 选择的关联词条
      checkedWritings: [], // 选中的词条
      isdisalbed: false,
      previousVersion: '', // 编辑之前的版本号
      parsing: false,
      pptxFileList: [] // PPT 文件列表
    }
  },
  created() {
    const id = this.$route.query.id
    if (id) {
      this.mainId = id
      api.getBrief({ id }).then(res => {
        if (res.status > 0 || res.errCode) {
          this.$router.replace('/')
          return
        }
        this.brief = res.data
        if (this.brief.status >= 1) {
          this.isdisalbed = true
        }
        if (this.brief.linkBrief) {
          api.getBrief({ id: this.brief.linkBrief }).then(res => {
            this.relatedReports.push(res.data)
          })
        }
        if (this.brief.writings.length) {
          api.searchWriting({ ids: this.brief.writings }).then(res => {
            this.checkedWritings = res.data.data.map(item => {
              return { title: item.title, _id: item._id }
            })
          })
        }
        localStorage.kind = this.brief.kind
        localStorage.title = this.brief.title
        localStorage.status = this.brief.status

        this.previousVersion = this.brief.version || ''
      })
    } else {
      const token = localStorage.passport
      this.brief.createdByName = this.$jwt.decode(token).name
    }
  },
  methods: {
    // 获取标签的数据
    getLabels(data) {
      this.brief.labels = data
    },
    // 获取股票代码的数据
    getStocks(data) {
      this.brief.stocks = data
    },
    // 获取厂牌的数据
    getbrandName(brandName) {
      this.brief.brandName = brandName
    },
    // 保存报告摘要 新增or更新
    handleSaveBrief() {
      this.$refs.briefRef.validate(async valid => {
        if (!valid) return
        // 是否确认调用接口，等于confirm时调用
        let confirm = 'confirm'
        if (this.mainId !== 0 && this.previousVersion === this.brief.version) {
          confirm = await this.$confirm(`您确定仍将此报告的版本号置为${this.brief.version}吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).catch(() => {})
        }
        const method = this.mainId === 0 ? 'post' : 'put'
        if (method === 'put') {
          this.brief._id = this.mainId
        }

        this.brief.brand = this.brief.brandName === '' ? null : this.brief.brand
        if (confirm === 'confirm') {
          // 幻灯片词条才关联词条
          if (this.brief.kind !== 1) {
            this.brief.writings = []
          }
          api
            .saveBrief(this.brief, method)
            .then(res => {
              this.$refs.labels.submit()
              this.handleResult(res, '保存摘要', cb => {
                localStorage.kind = this.brief.kind
                localStorage.title = this.brief.title
                // 存储brief的类型(横版、竖版)和标题
                const { _id, outline, status } = res.data
                this.mainId = _id
                this.brief._id = _id
                this.brief.outline = outline
                this.brief.status = status
                if (method === 'post') {
                  this.$router.replace('/reports/report/brief?id=' + _id)
                }
              })
            })
            .catch(err => {
              this.$message({ message: '保存摘要失败！' + err, type: 'error', duration: 2000 })
            })
        }
      })
    },
    // 移除报告头图
    handelRemoveImg() {
      this.brief.image = ''
      this.$forceUpdate()
    },
    // 上传图片成功后的回调
    handleUploaded(val) {
      if (val.errCode === 0) {
        this.brief.image = val.data.url
        this.$forceUpdate()
      }
    },
    // 上传头像图片验证
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      this.loading = true
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
        this.loading = false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 1MB!')
        this.loading = false
      }
      return isJPG && isLt2M
    },
    // 提交审核
    review() {
      api
        .briefReview({ _id: this.brief._id, status: 1 })
        .then(res => {
          const str = Enum.getLabel(1, Enum.STATUS)
          this.handleResult(res, `${str}`, () => {
            this.brief.status = 1
          })
        })
        .catch(err => {
          this.$message({ type: 'error', message: err })
        })
    },
    searchReports(val) {
      if (val.trim()) {
        api.searchBriefTitle({ text: val }).then(res => {
          this.relatedReports = res.data
        })
      }
    },
    searchBriefs(val) {
      if (val.trim()) {
        api.searchWriting({ title: val }).then(res => {
          this.relatedbriefs = res.data.data
        })
      }
    },
    // 把选中词条暂存，否则重新搜索后无法回显title
    changeWriting(val) {
      this.relatedbriefs.forEach(item => {
        if (val.includes(item._id) && !this.checkedWritings.find(it => it._id === item._id)) {
          this.checkedWritings.push({ _id: item._id, title: item.title, isCheckd: true })
        }
      })
    },
    // PPT 文件选择变更
    onPptxChange(file, fileList) {
      const isValid = file.name.endsWith('.pptx') || file.name.endsWith('.ppt')
      if (!isValid) {
        this.$message.error('只能上传 PPT/PPTX 文件')
        fileList.pop()
        return
      }
      this.pptxFileList = fileList
    },
    // 点击一键解析按钮 → 手动触发上传
    handleParseClick() {
      if (!this.pptxFileList.length) return
      this.parsing = true
      this.$refs.pptxUpload.submit()
    },
    // PPT 一键解析：上传成功
    onConvertSuccess(res) {
      this.parsing = false
      if (res.errCode === 0) {
        const count = res.data && res.data.outlines ? res.data.outlines.length : 0
        this.$notify({
          title: '解析成功',
          message: `已生成 ${count} 个目录`,
          type: 'success',
          duration: 0
        })
      } else {
        this.$notify({
          title: '解析失败',
          message: res.msg || '未知错误',
          type: 'error',
          duration: 0
        })
      }
    },
    // PPT 一键解析：上传失败
    onConvertError() {
      this.parsing = false
      this.$notify({
        title: '请求失败',
        message: '一键解析请求失败',
        type: 'error',
        duration: 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.report-step1 {
  .el-date-editor.el-input,
  .el-select {
    width: 100%;
  }

  .writing-label :deep().el-tag {
    display: flex;
    align-items: center;
    max-width: 100%;

    .el-select__tags-text {
      display: inline-block;
      max-width: calc(100% - 16px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .el-tag__close {
      margin-top: 1px;
    }
  }
}

.el-input-number--small {
  width: 180px;
}

.pptx-upload {
  ::v-deep .el-upload {
    display: inline-block;
  }

  ::v-deep .el-upload-list {
    margin-top: 8px;
  }

  ::v-deep .el-upload__tip {
    margin-top: 4px;
    line-height: 1.4;
  }

  ::v-deep .el-progress {
    display: none;
  }

  .pptx-parse-btn {
    margin-left: 12px;
  }
}
</style>
<style scoped>
.labels /deep/ .my_select {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}
</style>
